import { render, staticRenderFns } from "./PartnerSettings.vue?vue&type=template&id=32be7c88&scoped=true"
import script from "./PartnerSettings.vue?vue&type=script&lang=ts"
export * from "./PartnerSettings.vue?vue&type=script&lang=ts"
import style0 from "./PartnerSettings.vue?vue&type=style&index=0&id=32be7c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32be7c88",
  null
  
)

export default component.exports